import { Routes, Route } from 'react-router-dom';
import { OfferTermsView } from './views/OfferTermsView';

export const OfferTerms = () => {
    return (
        <Routes>
            <Route path="*" element={<OfferTermsView />} />
        </Routes>
    );
};
